import { Subscription, SubscriptionType } from '../../types/firm/Subscription'

export interface CheckFirmSubscriptionParams {
  subscription: Subscription | null
  isPremium?: boolean
}

/**
 * Check if the subscription is free
 * @param subscription - The subscription object
 * @returns true if the subscription is free, false otherwise
 */
export function isFreeSubscription(
  params: CheckFirmSubscriptionParams,
): boolean {
  if (!params.subscription) {
    return false
  }
  return params.subscription.name === SubscriptionType.FREE
}

/**
 * Check if the subscription is premium
 * @param subscription - The subscription object
 * @returns true if the subscription is premium, false otherwise
 */
export function isPremiumSubscription(
  params: CheckFirmSubscriptionParams,
): boolean {
  if (!params.subscription && !params.isPremium) {
    return false
  }
  return Boolean(
    params.subscription?.name === SubscriptionType.PREMIUM || params.isPremium,
  )
}

/**
 * Check if the subscription is attractivity
 * @param subscription - The subscription object
 * @returns true if the subscription is attractivity, false otherwise
 */
export function isAttractivitySubscription(
  params: CheckFirmSubscriptionParams,
): boolean {
  if (!params.subscription) {
    return false
  }
  return params.subscription.name === SubscriptionType.ATTRACTIVITY
}

/**
 * Check if the subscription is not client
 * @param subscription - The subscription object
 * @returns true if the subscription is not client, false otherwise
 */
export function isNotClientSubscription(
  params: CheckFirmSubscriptionParams,
): boolean {
  return !params.subscription && !params.isPremium
}
